var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { trimEnd } from 'lodash';
import jsonRoutes from './routes.json';
var routes = jsonRoutes;
export var isUrl = function (uri) {
    var matches = uri.match(/^(?:[a-z+]+:)?/);
    return matches != null && matches.length > 0 && matches[0].length > 0;
};
export var resolve = function (path) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, uriHost, uriPath, uriSegments, matchedRoute, name;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = uriInfo(path), uriHost = _a.host, uriPath = _a.path, uriSegments = _a.segments;
                return [4 /*yield*/, getFilteredUri(uriSegments)];
            case 1:
                matchedRoute = _c.sent();
                if (matchedRoute == null) {
                    return [2 /*return*/, null];
                }
                name = (_b = Object.keys(routes).find(function (key) { return routes[key] === matchedRoute; })) !== null && _b !== void 0 ? _b : '';
                return [2 /*return*/, {
                        hostname: uriHost,
                        name: name,
                        params: getParams(matchedRoute.uri, uriSegments),
                        pathname: uriPath,
                        uri: matchedRoute.uri,
                    }];
        }
    });
}); };
var uriInfo = function (path) {
    if (isUrl(path)) {
        var url = new URL(path);
        return {
            host: url.hostname,
            path: url.pathname,
            segments: url.pathname.split('/').filter(function (segment) { return segment.length > 0; }),
        };
    }
    return {
        host: '',
        path: path,
        segments: path.split('/').filter(function (segment) { return segment.length > 0; }),
    };
};
export var getFilteredUri = function (pathParts) { return __awaiter(void 0, void 0, void 0, function () {
    var routeMatches;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                routeMatches = Object.values(routes).filter(function (element) { return element.uri.includes(pathParts[0]); });
                if (routeMatches.length <= 1) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, filterRoutes(routeMatches, pathParts)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var filterRoutes = function (routeMatches, pathParts) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve) {
                    var iteration = 0;
                    var matches = 0;
                    var results = resolveUriParts(routeMatches, pathParts, iteration);
                    var tempResults = __spreadArray([], results, true);
                    var _loop_1 = function () {
                        results = resolveUriParts(results, pathParts, iteration);
                        if (matches > 0 && results.length === 0) {
                            // results are empty due to unmatched pathPart ( i.e. {param} )
                            var unMatchedParameter_1 = pathParts[iteration];
                            pathParts = pathParts.filter(function (item) { return item !== unMatchedParameter_1; });
                            results = __spreadArray([], tempResults, true);
                        }
                        else {
                            tempResults = __spreadArray([], results, true);
                            iteration++;
                        }
                        matches = results.length;
                    };
                    while (results.length > 1) {
                        _loop_1();
                    }
                    if (results.length === 1) {
                        resolve(results[0]);
                    }
                    else {
                        resolve(null); // Resolve with null if no single match is found
                    }
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var resolveUriParts = function (routeMatches, pathParts, iteration) {
    if (iteration === void 0) { iteration = 0; }
    if (pathParts.length === iteration + 1) {
        var result = routeMatches.filter(function (item) { return pathParts.every(function (part) { return item.uri.includes(part); }); });
        if (result.length === 1) {
            return result;
        }
        var reducer = result.filter(function (item) { return item.uri === pathParts.join('/'); });
        if (reducer.length === 1) {
            return reducer;
        }
    }
    var searchParams = '';
    for (var i = 0; i <= iteration; i++) {
        searchParams += pathParts[i] + (i !== pathParts.length ? '/' : '');
    }
    return Object.values(routeMatches).filter(function (element) { return element.uri.includes(searchParams); });
};
var getParams = function (uri, pathParts) {
    var params = {};
    var uriParts = uri.split('/');
    var regex = /\{([a-zA-Z_]+)(\??)}/g;
    var urlExpectedParams = uri.match(regex);
    if (urlExpectedParams === null) {
        return params;
    }
    urlExpectedParams.forEach(function (element) {
        var index = uriParts.indexOf(element);
        params[element.replace(/[{}]/g, '')] = pathParts[index];
    });
    return params;
};
export var resolveRoute = function (name, params) {
    if (Object.prototype.hasOwnProperty.call(routes, name)) {
        return uriParams("/".concat(routes[name].uri), params);
    }
    throw Error("Unknown route ".concat(name));
};
export var uriParams = function (uri, params) {
    var baseUri = uri;
    var urlExpectedParams = uri.match(/\{([a-zA-Z_]+)(\??)\}/g);
    if (urlExpectedParams != null) {
        urlExpectedParams.forEach(function (paramName) {
            var _a;
            var isOptional = paramName.indexOf('?') > 0;
            var filteredName = paramName.slice(1, isOptional ? -2 : -1);
            if (params === undefined && !isOptional) {
                throw Error("Missing param: ".concat(filteredName, " in ").concat(baseUri));
            }
            uri = replaceParam(uri, paramName, (_a = params === null || params === void 0 ? void 0 : params[filteredName]) !== null && _a !== void 0 ? _a : '');
        });
    }
    var finalUri = trimEnd(uri, '/');
    if (finalUri.length === 0) {
        return '/';
    }
    return finalUri;
};
var replaceParam = function (uri, paramName, param) { return uri.replace(paramName, param); };
